export enum MapperCadenceFrequency {
    Hour = 'Hour',
    Minute = 'Minute',
    Second = 'Second'
}

export enum MapperCadenceOption {
    SubMinute = '1 Minute',
    FifteenMinute = '15 minute',
    ThirtyMinute = '30 minute',
    OneHour = '1 hour',
    TwoHour = '2 hours'
}

export enum MapperFrequencyMode {
    Realtime = 'Realtime',
    Microbatch = 'Microbatch',
    None = 'Notselected'
}

export class MapperPolicyRecurrence {
    public readonly frequency: MapperCadenceFrequency;
    public readonly interval: number;

    constructor(frequency: MapperCadenceFrequency, interval: number) {
        this.frequency = frequency;
        this.interval = interval;
    }
}

